import _styled from '@emotion/styled/base';
import Grid from '@mui/material/Grid';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledGrid = /*#__PURE__*/_styled(Grid, {
  shouldForwardProp: isStyledPropsValid,
  target: "en2tugl0"
})(_ref => {
  let {
    theme,
    spacing
  } = _ref;
  if (!spacing) {
    return {};
  }
  return {
    '&.MuiGrid-container': {
      '& > .MuiGrid-item': {
        padding: 0,
        paddingLeft: theme.spacing(spacing),
        paddingTop: theme.spacing(spacing)
      }
    }
  };
}, "");
export { StyledGrid };